import styled, { css } from "styled-components";
import { parseCSS } from "scripts/FunctionsBundle";
import NewText from "@components/NewText";
import { Navigate, useParams } from "react-router-dom";
import { useContext } from "react";
import { GlobalContext } from "App";
import SearchTable from "@components/SearchTable";

// ################################ INTERFACES & PROPS ################################

type _Base = import("utils/class-types").Base;
// GameScreen => Rename all instances to use
type GameScreenProps = {} & _Base;

// ################################ RENDERING COMPONENT ################################

const _GameScreen = (props: GameScreenProps) => {
  const params = useParams();
  const global = useContext(GlobalContext);

  return (
    <div className={props.className + " screen"}>
      {global.get.GamesList.length <= 0 ? (
        <> Loading... </>
      ) : global.get.GamesList.map((val) => val.link).includes(
          params.gameID || ""
        ) ? (
        <></>
      ) : (
        <Navigate to={"/games"} replace={true} />
      )}
      <NewText
        _text={`This is the |{*}|${params.gameID}|| page`}
        _type={"title"}
        _variant={3}
        _align={"center"}
      />

      <SearchTable />
    </div>
  );
};

// ################################ STYLES ################################
const GameScreen = styled(_GameScreen).attrs((props): GameScreenProps => {
  return { ...props };
})`
  ${(props) => css`
    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################

export default GameScreen;
